import AddArtworkScreen from './AddArtworkScreen';

export default AddArtworkScreen;
